import React from 'react';

import itemContext from './itemContext';

export default function useItem() {
    return React.useContext(itemContext);
}
